const info = {
  ZH: { //中文翻译
    recipientList: "\u53D1\u9001\u72B6\u6001\u4FE1\u606F",
    index: "\u5E8F\u53F7",
    enterprise: "\u81F3\u4F01\u4E1A(\u90E8\u95E8)",
    name: "\u4F9B\u8D27\u540D\u79F0",
    symbol: "\u4F9B\u8D27\u7F16\u53F7",
    supplierCode: "\u4F9B\u5E94\u5546\u4EE3\u7801",
    recipStatus: "\u63A5\u6536\u72B6\u6001",
    recipStatus1: "\u7F16\u8F91\u6A21\u5F0F",
    recipStatus2: "\u5C1A\u672A\u6D4F\u89C8",
    recipStatus3: "\u5DF2\u6D4F\u89C8",
    recipStatus4: "\u5DF2\u6279\u51C6",
    recipStatus5: "\u5DF2\u62D2\u7EDD",
    recipStatus6: "\u88AB\u53D1\u9001\u4EBA\u53D6\u6D88",
    recipStatus7: "\u5DF2\u88AB\u4E0B\u8F7D",
    mdsInfo: " \u6750\u6599\u6570\u636E\u8868",
    mdsStatus1: " \u72B6\u6001\uFF1A\u5728\u7F16\u8F91\u4E2D",
    mdsStatus2: " \u72B6\u6001\uFF1A\u5185\u90E8\u53D1\u5E03",
    mdsStatus3: " \u72B6\u6001\uFF1A\u5DF2\u53D1\u9001",
    mdsStatus4: " \u72B6\u6001\uFF1A\u5DF2\u63D0\u4EA4",
    mdsStatus5: " \u72B6\u6001\uFF1A\u5DF2\u53D1\u5E03",
    mdsIdAndVer: "ID/\u7248\u672C\uFF1A",
    modelname: " \u53D1\u9001\u72B6\u6001\u4FE1\u606F",
    modelpath1: " \u67E5\u627E",
    modelpath2: " \u7F16\u8F91",
    modelpath3: " \u6750\u6599\u6570\u636E\u8868",
    modelpath4: " \u53D1\u9001\u72B6\u6001\u4FE1\u606F",
    modelpathflag: " >>",
    send: "\u53D1\u9001",
    submit: "\u63D0\u4EA4",
    inner: "\u5185\u90E8",
    publish: "\u53D1\u5E03",
    return: "\u4E0A\u4E00\u6B65",
    addRecipient: "\u6DFB\u52A0\u63A5\u6536\u65B9",
    view: "\u67E5\u770B",
    modify: "\u4FEE\u6539",
    delete: "\u5220\u9664",
    save: "\u4FDD\u5B58",
    cancel: "\u53D6\u6D88",
    searchResult: "\u67E5\u627E\u7ED3\u679C",
    returnMds: "\u8FD4\u56DEMDS",
    errorMessage1: " \u4E0D\u80FD\u6DFB\u52A0\u672C\u4F01\u4E1A\u6216\u90E8\u95E8\uFF01",
    errorMessage2: " \u4E0D\u80FD\u5C06\u4E24\u4E2A\u76F8\u540C\u7684\u4F01\u4E1A\u52A0\u5165\u5217\u8868\uFF0C\u5C31\u7B97\u5176\u90E8\u95E8\u4E0D\u540C\uFF01",
    errorMessage3: " MDS\u4FE1\u606F\u672A\u4FDD\u5B58\uFF0C\u8BF7\u5148\u4FDD\u5B58MDS\u4FE1\u606F\uFF01",
    errorMessage4: " \u672C\u4F01\u4E1A\u4FE1\u606F\u4E0D\u5B8C\u6574\uFF0C\u8BF7\u5148\u7EF4\u62A4\u672C\u4F01\u4E1A\u4FE1\u606F\uFF01",
    deleteMessage: " \u60A8\u786E\u5B9A\u8981\u4ECE\u5217\u8868\u4E2D\u5220\u9664\u6B64\u63A5\u6536\u4EBA\u5417?",
    saveMessage: " \u6570\u636E\u4FDD\u5B58\u6210\u529F\uFF01",
    selectOne: " \u8BF7\u9009\u62E9\u4E00\u6761\uFF01",
    message1: " \u63A5\u6536\u4EBA\u5217\u8868\u4E2D\u5B58\u5728\u8BB0\u5F55\uFF0C\u5982\u679C\u201C\u5185\u90E8\u53D1\u5E03\u201D\uFF0C\u5219\u4E0D\u4F1A\u7ED9\u63A5\u6536\u7528\u6237\u53D1\u9001\u4FE1\u606F\uFF0C\u662F\u5426\u7EE7\u7EED\u201C\u5185\u90E8\u53D1\u5E03\u201D\uFF1F",
    message2: " \u63A5\u6536\u4EBA\u5217\u8868\u4E2D\u5B58\u5728\u8BB0\u5F55\uFF0C\u5982\u679C\u201C\u53D1\u5E03\u201D\uFF0C\u5219\u4E0D\u4F1A\u7ED9\u63A5\u6536\u7528\u6237\u53D1\u9001\u4FE1\u606F\uFF0C\u662F\u5426\u7EE7\u7EED\u201C\u53D1\u5E03\u201D\uFF1F",
    saveMessageA: " MDS\u53D1\u9001\u6210\u529F\uFF01",
    saveMessageB: " MDS\u63D0\u4EA4\u6210\u529F\uFF01",
    saveMessageC: " MDS\u5185\u90E8\u63D0\u4EA4\u6210\u529F\uFF01",
    saveMessageD: " MDS\u53D1\u5E03\u6210\u529F\uFF01",
    checkForChange: '\u63A5\u6536\u65B9\u7684\u201C\u4F01\u4E1A\u76F8\u5173\u6570\u636E"\u5FC5\u586B\u9879\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u586B\u5199\u5B8C\u6574\u3002',
    backMds: " \u8FD4\u56DEMDS",
    check: "\u6821\u9A8C",
    responsible: " \u6211\u627F\u8BFA",
    cancle: " \u53D6\u6D88",
    responsibleTitle: " \u8D23\u4EFB\u627F\u8BFA\u4E66",
    recipientData: "\u4F01\u4E1A\u4FE1\u606F",
    modelname: " \u4F01\u4E1A\u76F8\u5173\u6570\u636E",
    recUserId: "\u63A5\u6536\u7528\u6237",
    recOrgId: "\u63A5\u6536\u4F01\u4E1A\u90E8\u95E8\u4EE3\u7801",
    supplierCode: "\u4F9B\u5E94\u5546\u4EE3\u7801",
    symbol: "\u4F9B\u8D27\u7F16\u53F7(\u7531\u5BA2\u6237\u6307\u5B9A)",
    mdsName: "\u4F9B\u8D27\u540D\u79F0",
    drawingId: "\u5236\u56FE\u53F7",
    drawingDate: "\u5236\u56FE\u65E5\u671F",
    drawingModCode: "\u5236\u56FE\u4FEE\u6539\u53F7",
    reportCode: "\u62A5\u8868\u7F16\u53F7",
    reportDate: "\u62A5\u8868\u65E5\u671F",
    purchaseOrderNo: "\u8D2D\u8D27\u8BA2\u5355\u53F7",
    billOfLading: "\u63D0\u8D27\u5355\u53F7",
    denialReason: "\u62D2\u7EDD\u539F\u56E0",
    forwordAllowed: "\u5141\u8BB8\u8F6C\u53D1",
    yes: "\u662F",
    no: "\u5426",
    remark: "\u5907\u6CE8",
    dateformat: "[\u5E74(4\u4F4D)-\u6708(2\u4F4D)-\u65E5(2\u4F4D)]",
    cancel: "\u53D6\u6D88",
    errorMessage6: " \u4F9B\u5E94\u5546\u4EE3\u7801\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u8F93\u5165\uFF01",
    errorMessage7: " \u4F9B\u8D27\u7F16\u53F7\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u8F93\u5165\uFF01",
    errorMessage8: " \u4F9B\u8D27\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u8F93\u5165\uFF01",
    errorMessage9: " \u201C\u5236\u56FE\u65E5\u671F\u201D\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\uFF01",
    errorMessage5: " \u201C\u62A5\u8868\u65E5\u671F\u201D\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\uFF01",
    message: " \u60A8\u8FD8\u6CA1\u6709\u4FDD\u5B58\u6570\u636E,\u60A8\u786E\u5B9A\u7EE7\u7EED\u64CD\u4F5C\u5417?",
    symbolPlaceholder: "\u8BF7\u52A1\u5FC5\u8054\u7CFB\u60A8\u7684\u5BA2\u6237\u786E\u8BA4\u4F9B\u8D27\u7F16\u53F7",
    checkRequirements: "	\u8868\u5355\u5BA1\u6838\u8981\u6C42",
    checkDownload: "	\u4E0B\u8F7D",
    cfrName:"供货名称(外文)"
  },
  EN: { //英文翻译
    recipientList: "	Recipient data",
    index: "	No.",
    enterprise: "	To the enterprise (Department)",
    name: "Designated Name by customer ",
    symbol: "Designated Component No. by customer ",
    drawingNo: "	Drawing No.",
    supplierCode: " Supplier Code",
    recipStatus: "	Recipient Status",
    recipStatus1: "	Edit mode",
    recipStatus2: "	not yet browsed",
    recipStatus3: "	seen",
    recipStatus4: "	Accepted",
    recipStatus5: "	Rejected",
    recipStatus6: "Canceled by the sender",
    recipStatus7: "DownLoaded",
    mdsInfo: "MDS",
    mdsStatus1: "status\uFF1AEdit mode",
    mdsStatus2: "status\uFF1Ainternally released",
    mdsStatus3: "status\uFF1ASent",
    mdsStatus4: "status\uFF1Aproposed",
    mdsStatus5: "status\uFF1APublished",
    mdsIdAndVer: "ID/Version\uFF1A",
    modelname: "	recipient status",
    modelpath1: "	Search",
    modelpath2: "	Edit",
    modelpath3: "	MDS",
    modelpath4: "	recipient status management",
    modelpathflag: "	 >>",
    send: "	Send",
    submit: "	Submit",
    inner: "	Internal",
    publish: "	Publish",
    return: "	Back",
    addRecipient: "	Add recipients",
    view: "View",
    modify: "	Modify",
    delete: "	Delete",
    save: "	Save",
    cancel: "	Cancel",
    searchResult: "	SearchResult",
    returnMds: "Return",
    errorMessage1: " 	You can't send or propose an MDS to your own enterprise or one of its departments.",
    errorMessage2: "Two same enterprises can not be added to the list,even if their departments are different\! ",
    errorMessage3: "	MDS has not been saved. Please save MDS first!",
    errorMessage4: "	The supplier information is incomplete. Please maintain the supplier information first!",
    deleteMessage: "	Are you sure to delete this recipient from the list?",
    saveMessage: "	Saved sucessfully!",
    selectOne: "	Please select an item!",
    message1: 'The records are stored in the list of recipients. If you choose "inner publication", then the message is not sent to the recipients. Do you continue "inner publication"?',
    message2: 'The records are stored in the list of recipients. If you choose "publication", then the message is not sent to the recipients. Do you continue "publication"?',
    saveMessageA: "	MDS has been sent successfully!",
    saveMessageB: "	MDS has been submitted successfully!",
    saveMessageC: "	MDS has been internally submitted successfully!",
    saveMessageD: "	MDS has been published successfully!",
    checkForChange: " The MDS recipient information is required. Please input.",
    backMds: "Return",
    check: "Check",
    recipientData: " Enterprise information",
    modelname: " Enterprise information",
    recUserId: " Recipient",
    recOrgId: " Receiving Enterprise(Organiation) ID",
    supplierCode: " Supplier code",
    symbol: " Designated Component No.by customer",
    mdsName: " Designated Name by customer",
    drawingId: " Drawing No.",
    drawingDate: " Drawing date",
    drawingModCode: " Drawing Change Level",
    reportCode: " Report No.",
    reportDate: " Report date",
    purchaseOrderNo: " Purchase order No.",
    billOfLading: " Bill of delivery No.",
    denialReason: "Reason for denial:",
    forwordAllowed: " Forwarding is allowed",
    yes: " Yes",
    no: " No",
    remark: " Remark",
    dateformat: " [Year(four digits) - Month(two digits) - Day(two digits)]",
    cancel: " Cancel",
    errorMessage1: " The supplier code can not be blank.Please enter!",
    errorMessage2: " The Component No.Designated by customer can not be blank.Please enter\!",
    errorMessage3: " The Name Designated by customer can not be blank.Please enter\!",
    errorMessage4: '"drawing date" format error. Please input again!',
    errorMessage5: '"report date" format error. Please input again!',
    message: " You have not saved the data.Are you sure to continue the operation ? ",
    symbolPlaceholder: " Please make sure you have already confirmed the supplied component number with your customer.",
    checkRequirements: " check requirements",
    checkDownload: " download",
    cfrName:"Designated Name by customer(Foreign)"
  }
}
export default info //需要暴露出去
